__webpack_require__.p = "https://magnify.dev.magmutual.com/";